<template>
  <div :class="['micad_logo', getType(type)]"></div>
</template>

<script>
export default {
  name: 'Icons',
  props: {
    type: String,
  },
  methods: {
   getType(type) {
      if (type !== undefined) {
        return ' micad_logo_'+type
      }
    },
  }
};
</script>

